import { Lightning } from '@lightningjs/sdk';
import { makeButtonTexture } from './buttonTexture.utils';

export class ButtonTexture extends Lightning.Component {
  _construct() {
    this._generatedTextureWidth = 0;
    this._generatedTextureHeight = 0;
    this._fillColor = 0;
    this._borderColor = 0;
    this._borderWidth = 0;
    this._borderRadius = 0;
    this._fillColor = 0;
    this._shouldUpdateTexture = false;
  }

  _attach() {
    this._shouldUpdateTexture = true;
    this.onUpdate = ({ finalW, finalH }) => {
      if (finalW !== this._generatedTextureWidth || finalH !== this._generatedTextureHeight) {
        this._generatedTextureWidth = finalW;
        this._generatedTextureHeight = finalH;
        this._updateButtonTexture();
      }
    };
  }

  _detach() {
    this._shouldUpdateTexture = false;
    this.onUpdate = undefined;
  }

  get borderColor() {
    return this._borderColor;
  }

  set borderColor(value) {
    this._borderColor = value;
    this._updateButtonTexture();
  }

  get borderWidth() {
    return this._borderWidth;
  }

  set borderWidth(value) {
    this._borderWidth = value;
  }

  get borderRadius() {
    return this._borderRadius;
  }

  set borderRadius(value) {
    this._borderRadius = value;
  }

  get color() {
    return this._fillColor;
  }

  set color(value) {
    this._fillColor = value;
    this._updateButtonTexture();
  }

  _updateButtonTexture() {
    if (!this._shouldUpdateTexture || !this._generatedTextureWidth || !this._generatedTextureHeight) {
      return;
    }

    this.texture = makeButtonTexture(
      this._generatedTextureWidth,
      this._generatedTextureHeight,
      this._borderRadius,
      this._borderWidth,
      this._borderColor,
      this._fillColor,
    );
  }
}
